import { CancellationReasonsService } from 'data/services';
import { CancellationReasonsServiceInterface } from 'domain/services';
import { makeGetAllCancellationReasons } from 'main/factories/usecases/cancellation-reasons/remote-get-all-cancellation-reasons-factory';

export const makeCancellationReasonsService =
  (): CancellationReasonsServiceInterface => {
    return new CancellationReasonsService(makeGetAllCancellationReasons());
  };
